import { Box, Button, Dialog, Grid, IconButton, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { ProceedSaveLater, SubHeading } from './components';
import { Formik, FormikHelpers, validateYupSchema, yupToFormErrors } from 'formik';
import MFSelectField from '../../lib/formik/SelectField';
import UseRadioGroup from '../../lib/formik/Radio';
import CloseIcon from '@mui/icons-material/Close';
import { MFTextField } from '../../lib/formik';
import {
  Applicant,
  tinCountriesList,
  tinValidateResponse,
} from '../../redux-store/types/api-types';
import {
  addressTypesMasters,
  AMC_APPROVER_CHECK_FOR_INDIVIDUAL,
  ReasonTinMaster,
  tin_declaration_validation_date,
  USER_ROLES,
  yesNoTureFalseMaster,
} from '../../utils/constant';
import {
  applicationComparison,
  applyRoleBasedStatus,
  checkValidationBasedOnDate,
  getApplicantName,
  getCurrentStep,
  isNriInvestorType,
  OthersTINReason,
  navigateToNextStep,
  removeSingleQuote,
  saveForLater,
} from '../../utils/utilityFunctions';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import { useHistory, useLocation } from 'react-router';
import { updateApplication } from '../../redux-store/actions/application';
import { FATCAValidationSchema } from '../../utils/schema';
import { Notes } from './components';
import { useSnackbar } from 'notistack';
import { mdmsCountriesList, nationaliyType } from '../../redux-store/types/mdms';
import { getNationalityList } from '../../redux-store/actions';
import { SearchableSelect } from '../../lib/formik/searchSelectField';
import { getTinCountriesList, validateTin } from '../../redux-store/actions/onBoarding';
import { LoadingButton } from '@mui/lab';
import MFCheckbox from '../../lib/formik/Checkbox';
import { showError } from '../../redux-store/actions/auth';
import { useFeatureToggles } from '../../utils/useDataMdms';
import { fatcaTinDeclaration } from '../../utils/declaration';
export type Values = {
  applicants: Partial<Applicant>[];
  saveType: string;
  countryDropdown: string[];
  allCountryDropdown: string[];
};

const initialValues: Values = {
  applicants: [
    {
      typeOfAddressProvidedAtKRA: '',
      taxResidentOfAnyCountryOtherThanIndia: false,
      placeOfBirth: '',
      countryOfBirth: 'INDIA',
      countryOfNationality: 'INDIA',
      taxCountryName: '',
      taxID: '',
      idType: '',
      nameOfEntity: '',
      dateOfIncorporation: '',
      cityOfIncorporation: '',
      countryOfIncorporation: '',
      entityExcemptionCode: '',
      isTinVerified: [null],
      tinExists: false,
      id: 1,
      tinNotAvailable: false,
      tinNotAvlReason: '',
      tinNotAvlReasonOthers: '',
    },
  ],
  saveType: 'save and proceed',
  countryDropdown: [],
  allCountryDropdown: [],
};

const FatcaDetails = ({
  applicantName,
  index,
  values,
  nationalitiesMdmsResponse,
  mdmsAllCountriesList,
  tinCountries,
  formvalues,
  setValues,
}: {
  applicantName: string;
  index: number;
  values: Partial<Applicant>;
  nationalitiesMdmsResponse: mdmsCountriesList[];
  mdmsAllCountriesList: mdmsCountriesList[];

  tinCountries: tinCountriesList[];
  formvalues: Values;
  setValues: FormikHelpers<Values>['setValues'];
}): JSX.Element => {
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const isFieldDisabled = [USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role);
  const { application } = useSelector((store: RootStateType) => store.application);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const validateTinForApplicant = async () => {
    try {
      setLoading(true);
      if (values?.taxCountryName && values?.taxID) {
        const CountryCode = tinCountries?.find(
          (country) => country.countryName === values?.taxCountryName
        )?.countryCode;
        const res = (await dispatch(
          validateTin({
            TINFormat: 'Individuals',
            TINNo: values?.taxID,
            CountryCode: (CountryCode as string) || '',
            IdTypeCode: 'T',
            applicantId: formvalues?.applicants[index]?.id?.toString() || '',
          })
        )) as unknown as tinValidateResponse;

        setValues({
          ...formvalues,
          applicants: formvalues?.applicants?.map((applicant, ind) => {
            if (index === ind) {
              return {
                ...applicant,
                isTinVerified: [res?.isTinVerified],
              };
            }
            return applicant;
          }),
        });
      }
    } catch (e) {
      console.error((e as Error).message);
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <SubHeading>FATCA Details of {applicantName} Applicant</SubHeading>
      <Grid item xs={12} sm={6}>
        <MFSelectField
          name={`applicants.${index}.typeOfAddressProvidedAtKRA`}
          label="Type of Address Provided At KRA *"
          items={addressTypesMasters.map((address) => ({ key: address, value: address }))}
        />
      </Grid>
      <Grid item xs={12}>
        <UseRadioGroup
          formLabel="Tax Resident of any country other than India *"
          name={`applicants.${index}.taxResidentOfAnyCountryOtherThanIndia`}
          items={Object.keys(yesNoTureFalseMaster).map((item) => ({
            label: yesNoTureFalseMaster[item],
            value: item,
          }))}
          value={values.taxResidentOfAnyCountryOtherThanIndia?.toString()}
          disabled={isFieldDisabled}
        />
      </Grid>
      {/* {applicant?.taxResidentOfAnyCountryOtherThanIndia?.toString() === 'true' && ( */}
      <>
        <Grid item xs={12} sm={6}>
          <MFTextField
            name={`applicants.${index}.placeOfBirth`}
            label="Place of Birth *"
            placeholder="Enter Place of Birth"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          {/* <MFTextField
            name={`applicants.${index}.countryOfBirth`}
            label="Country of Birth *"
            placeholder="Enter Country of Birth"
            disabled={isFieldDisabled}
          /> */}
          <SearchableSelect
            name={`applicants.${index}.countryOfBirth`}
            label="Country of Birth *"
            items={mdmsAllCountriesList?.map((nationality) => ({
              key: nationality.name,
              value: nationality.name,
            }))}
            disabled={isFieldDisabled}
            searchFieldPlaceholder={'Search Country'}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          {/* <MFTextField
            name={`applicants.${index}.countryOfNationality`}
            label="Country of Nationality *"
            placeholder="Enter Country of Nationality"
            disabled={isFieldDisabled}
          /> */}
          <SearchableSelect
            name={`applicants.${index}.countryOfNationality`}
            label="Country of Nationality *"
            items={nationalitiesMdmsResponse.map((nationality) => ({
              key: nationality.name,
              value: nationality.name,
            }))}
            disabled={isFieldDisabled}
            searchFieldPlaceholder={'Search Country'}
          />
        </Grid>
        {values?.taxResidentOfAnyCountryOtherThanIndia?.toString() === 'true' && (
          <>
            {checkValidationBasedOnDate(
              application?.createdAt || '',
              tin_declaration_validation_date
            ) &&
              isNriInvestorType(application?.applicants[index]?.status || '') && (
                <>
                  <Grid item xs={12}>
                    <MFCheckbox
                      name={`applicants.${index}.tinNotAvailable`}
                      label={fatcaTinDeclaration}
                      sx={{ mt: 1 }}
                      onChange={({ target: { checked } }) => {
                        return setValues({
                          ...formvalues,
                          applicants: formvalues?.applicants?.map((applicant, ind) => {
                            if (index === ind) {
                              return {
                                ...applicant,
                                tinNotAvailable: checked,
                                isTinVerified: [null],
                                taxID: '',
                                taxCountryName: '',
                              };
                            }
                            return applicant;
                          }),
                        });
                      }}
                    />
                  </Grid>
                  {checkValidationBasedOnDate(
                    application?.createdAt || '',
                    tin_declaration_validation_date || ''
                  ) &&
                    values.tinNotAvailable === true && (
                      <>
                        <Grid item xs={12} sm={6}>
                          <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
                            <MFSelectField
                              name={`applicants.${index}.tinNotAvlReason`}
                              label={'Reason:'}
                              items={Object.keys(ReasonTinMaster).map((reason) => ({
                                key: ReasonTinMaster[reason].code,
                                value: reason,
                              }))}
                            />
                            <Typography component="span" ml={1} sx={{ cursor: 'pointer' }}>
                              <InfoOutlinedIcon
                                color="info"
                                fontSize="small"
                                onClick={handleOpen}
                              />
                            </Typography>
                          </Box>
                        </Grid>
                        {OthersTINReason(values.tinNotAvlReason || '') && (
                          <Grid item xs={12} sm={6}>
                            <MFTextField
                              name={`applicants.${index}.tinNotAvlReasonOthers`}
                              label="Please specify Reason*"
                              placeholder="Enter Reason"
                            />
                          </Grid>
                        )}
                        {/* <Grid>
                          <Typography>{fatcaDeclaration1}</Typography>
                          <Typography>{fatcaDeclaration2}</Typography>
                          <Typography>{fatcaDeclaration3}</Typography>
                        </Grid> */}
                      </>
                    )}
                </>
              )}
            {!values?.tinNotAvailable && (
              <Grid item xs={12} sm={6}>
                <SearchableSelect
                  name={`applicants.${index}.taxCountryName`}
                  label="Tax country Name *"
                  items={tinCountries
                    .filter((e) => e.countryName?.toLowerCase() !== 'india')
                    .map((nationality) => ({
                      key: nationality.countryName,
                      value: nationality.countryName,
                    }))}
                  disabled={isFieldDisabled}
                  searchFieldPlaceholder={'Search Country'}
                  onChange={({ target: { value } }) => {
                    setValues({
                      ...formvalues,
                      applicants: formvalues?.applicants?.map((applicant, ind) => {
                        if (index === ind) {
                          return {
                            ...applicant,
                            taxCountryName: value as string,
                            isTinVerified: [null],
                          };
                        }
                        return applicant;
                      }),
                    });
                  }}
                />
              </Grid>
            )}
            {/* {checkValidationBasedOnDate(
              application?.createdAt || '',
              tin_declaration_validation_date
            ) && (
              <Grid item xs={12}>
                <MFCheckbox
                  name={`applicants.${index}.tinExists`}
                  label="TIN does not exist"
                  sx={{ mt: 1 }}
                  onChange={({ target: { checked } }) => {
                    return setValues({
                      ...formvalues,
                      applicants: formvalues?.applicants?.map((applicant, ind) => {
                        if (index === ind) {
                          return {
                            ...applicant,
                            tinExists: checked,
                            isTinVerified: [null],
                          };
                        }
                        return applicant;
                      }),
                    });
                  }}
                />
              </Grid>
            )} */}
            {((checkValidationBasedOnDate(
              application?.createdAt || '',
              tin_declaration_validation_date
            ) &&
              !values?.tinNotAvailable) ||
              !checkValidationBasedOnDate(
                application?.createdAt || '',
                tin_declaration_validation_date
              )) && (
              <>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.taxID`}
                    label="Tax ID *"
                    placeholder="Enter Tax ID"
                    disabled={isFieldDisabled}
                    onChange={({ target: { value } }) => {
                      setValues({
                        ...formvalues,
                        applicants: formvalues?.applicants?.map((applicant, ind) => {
                          if (index === ind) {
                            return {
                              ...applicant,
                              taxID: value,
                              isTinVerified: [null],
                            };
                          }
                          return applicant;
                        }),
                      });
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.idType`}
                    label="ID Type *"
                    placeholder="Enter ID Type"
                    disabled={
                      isFieldDisabled ||
                      checkValidationBasedOnDate(
                        application?.createdAt || '',
                        tin_declaration_validation_date
                      )
                    }
                    onChange={({ target: { value } }) => {
                      setValues({
                        ...formvalues,
                        applicants: formvalues?.applicants?.map((applicant, ind) => {
                          if (index === ind) {
                            return {
                              ...applicant,
                              idType: value,
                              isTinVerified: [null],
                            };
                          }
                          return applicant;
                        }),
                      });
                    }}
                  />
                </Grid>
              </>
            )}
            {checkValidationBasedOnDate(
              application?.createdAt || '',
              tin_declaration_validation_date
            ) &&
              !values?.tinNotAvailable && (
                <Grid
                  item
                  xs={12}
                  display="flex"
                  justifyContent="space-between"
                  sx={{
                    width: '100%',
                    flexDirection: { xs: 'column-reverse', sm: 'row' },
                    alignItems: { xs: 'flex-start', sm: 'center' },
                  }}>
                  <Grid
                    xs={12}
                    sm={6}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                    }}>
                    <LoadingButton
                      loadingPosition="end"
                      loading={loading}
                      disabled={
                        [true, false].includes(
                          (values?.isTinVerified?.length
                            ? values?.isTinVerified[0]
                            : false) as boolean
                        ) || loading
                      }
                      variant="contained"
                      sx={{ fontWeight: 500, fontSize: 14, width: '100%' }}
                      onClick={() => validateTinForApplicant()}>
                      Verify Tin
                    </LoadingButton>
                  </Grid>
                  {values.isTinVerified && values?.isTinVerified[0] !== null && (
                    <Grid
                      sm={6}
                      xs={12}
                      sx={{ position: 'relative', bottom: 10, mb: { xs: 2, sm: 0 } }}>
                      <Typography
                        component="div"
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          padding: { xs: 0, sm: '10px 20px' },
                          borderRadius: '5px',
                          alignItems: 'flex-start',
                          mt: 2,
                          width: '100%',
                          boxSizing: 'border-box',
                        }}>
                        <InfoOutlinedIcon color="info" fontSize="small" />
                        <Typography
                          sx={{
                            color: 'rgba(41, 49, 57, 0.7)',
                            fontSize: '13px',
                            fontWeight: 500,
                            ml: 1,
                          }}>
                          {!!values?.isTinVerified[0] === true
                            ? 'Tin verified successfully'
                            : values?.isTinVerified[0] === false
                            ? 'Tin verification failed'
                            : ''}
                        </Typography>
                      </Typography>
                    </Grid>
                  )}
                </Grid>
              )}
          </>
        )}
        {/* <Grid item xs={12} sm={6}>
            <MFTextField
              name={`applicants.${index}.nameOfEntity`}
              label="Name of Entity"
              placeholder="Enter Name of Entity"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <DatePicker
              label="Date of Incorporation"
              inputLabelStyles={{
                transform: 'unset',
                fontSize: 14,
                fontWeight: 500,
                color: 'rgba(0,0,0,0.7)',
              }}
              maxDate={minDateForContributor()}
              name={`applicants.${index}.dateOfIncorporation`}
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              value={applicant.dateOfBirth || minDateForContributor().toString()}
              onChange={(newValue) => {
                setValues({
                  ...values,
                  applicants: values.applicants.map((applicant, ind) => {
                    if (index === ind) {
                      return {
                        ...applicant,
                        dateOfIncorporation: newValue?.toString(),
                      };
                    }
                    return applicant;
                  }),
                });
              }}
              textFieldStyles={{
                'label + &': {
                  mt: 4,
                },
                '& .MuiInputBase-root': {
                  border: '1px solid #DDEAF3',
                },
                '& .MuiOutlinedInput-root': {
                  position: 'relative',
                  backgroundColor: 'common.white',
                  border: '1px solid #DDEAF3',
                  fontSize: 16,
                  '&:hover': {
                    borderColor: 'primary.main',
                    '.MuiOutlinedInput-notchedOutline': {
                      border: 0,
                    },
                  },
                  '.MuiOutlinedInput-notchedOutline': {
                    border: 0,
                  },
                  '.MuiInputBase-input': {
                    p: '10px 12px',
                  },
                  '&:focus-visible': {
                    outline: 'none',
                  },
                },
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MFTextField
              name={`applicants.${index}.cityOfIncorporation`}
              label="City of Incorporation"
              placeholder="Enter City of Incorporation"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MFTextField
              name={`applicants.${index}.countryOfIncorporation`}
              label="Country of Incorporation"
              placeholder="Enter Country of Incorporation"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MFTextField
              name={`applicants.${index}.entityExcemptionCode`}
              label="Entity Exemption Code"
              placeholder="Enter Entity Exemption Code"
            />
          </Grid> */}
      </>
      {/* )} */}
      <Dialog
        onClose={handleClose}
        open={open}
        sx={{
          '.MuiPaper-root ': {
            maxWidth: 800,
            p: { xs: 2, sm: '15px 5px 35px' },
            borderRadius: '10px',
            height: 'unset',
            overflowY: 'auto',
          },
        }}>
        <IconButton onClick={handleClose} sx={{ alignSelf: 'flex-end' }}>
          <CloseIcon fontSize="medium" />
        </IconButton>
        <Box
          sx={{
            width: { xs: '100%', sm: '90%' },
            mx: 'auto',
            '.MuiTypography-root': {
              textAlign: 'start',
              fontFamily: 'Work Sans,sans-serif',
            },
          }}>
          <Typography sx={{ fontSize: 16, fontWeight: 400 }}>
            *If a TIN is unavailable, please provide the appropriate reason A, B or C as defined
            below:
          </Typography>
          <Typography sx={{ fontSize: 16, fontWeight: 400, pt: 1 }}>
            <Typography sx={{ fontSize: 16, fontWeight: 500 }} component="span">
              Reason A –{' '}
            </Typography>
            {ReasonTinMaster.reason_a.description}
          </Typography>
          <Typography sx={{ fontSize: 16, fontWeight: 400, pt: 1 }}>
            <Typography sx={{ fontSize: 16, fontWeight: 500 }} component="span">
              Reason B –{' '}
            </Typography>
            {ReasonTinMaster.reason_b.description}
          </Typography>
          <Typography sx={{ fontSize: 16, fontWeight: 400, pt: 1 }}>
            <Typography sx={{ fontSize: 16, fontWeight: 500 }} component="span">
              Reason C –{' '}
            </Typography>
            {ReasonTinMaster.reason_c.description}
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Button
              variant="contained"
              sx={{ minWidth: { xs: '170px', sm: '220px' }, mt: 3 }}
              onClick={handleClose}>
              Done
            </Button>
          </Box>
        </Box>
      </Dialog>
    </>
  );
};

export default function Fatca(): JSX.Element {
  const [fatcaDetails, setFatcaDetails] = useState(initialValues);
  const [loading, setLoading] = useState(false);
  const { application } = useSelector((store: RootStateType) => store.application);
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const dispatch = useDispatch();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const [mdmsCountriesList, setMdmsCountriesList] = useState<mdmsCountriesList[]>([]);
  const [mdmsAllCountriesList, setMdmsAllCountriesList] = useState<mdmsCountriesList[]>([]);

  const [tinCountries, setTinCountries] = useState<tinCountriesList[]>([]);
  const { toggler } = useFeatureToggles();
  const location = useLocation();
  const path = location.pathname;

  useEffect(() => {
    (async function () {
      try {
        const nationalitiesMdmsMasters = (await dispatch(
          getNationalityList()
        )) as unknown as nationaliyType;
        setMdmsCountriesList(nationalitiesMdmsMasters.countries);
        setMdmsAllCountriesList(nationalitiesMdmsMasters.allCountries);
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, []);

  useEffect(() => {
    (async function () {
      try {
        const response = (await dispatch(getTinCountriesList())) as unknown as tinCountriesList[];
        setTinCountries(response);
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, []);

  useEffect(() => {
    const { applicants = [], createdAt = '' } = application || {};
    (async function () {
      try {
        const nationalitiesMdmsMasters = (await dispatch(
          getNationalityList()
        )) as unknown as nationaliyType;
        setMdmsCountriesList(nationalitiesMdmsMasters.countries);
        setMdmsAllCountriesList(nationalitiesMdmsMasters.allCountries);
        setFatcaDetails({
          ...fatcaDetails,
          applicants: applicants?.map((applicant) => ({
            id: applicant.id,
            typeOfAddressProvidedAtKRA: applicant.typeOfAddressProvidedAtKRA || '',
            taxResidentOfAnyCountryOtherThanIndia:
              applicant.taxResidentOfAnyCountryOtherThanIndia || false,
            placeOfBirth: applicant.placeOfBirth || '',
            countryOfBirth: applicant.countryOfBirth
              ? applicant.countryOfBirth.toUpperCase()
              : [USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role)
              ? ''
              : 'INDIA',
            countryOfNationality: applicant.countryOfNationality
              ? applicant.countryOfNationality.toUpperCase()
              : [USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role)
              ? ''
              : 'INDIA',
            taxCountryName: applicant.taxCountryName || '',
            taxID: applicant.taxID || '',
            idType:
              applicant.idType ||
              checkValidationBasedOnDate(createdAt || '', tin_declaration_validation_date)
                ? 'TIN'
                : '',
            nameOfEntity: applicant.nameOfEntity || '',
            dateOfIncorporation: applicant.dateOfIncorporation || '',
            cityOfIncorporation: applicant.cityOfIncorporation || '',
            countryOfIncorporation: applicant.countryOfIncorporation || '',
            entityExcemptionCode: applicant.entityExcemptionCode || '',
            isTinVerified: [applicant.isTinVerified ? applicant.isTinVerified[0] : null],
            tinExists: applicant.tinExists || false,
            tinNotAvailable:
              checkValidationBasedOnDate(
                application?.createdAt || '',
                tin_declaration_validation_date
              ) && isNriInvestorType(applicant.status || '')
                ? applicant.tinNotAvailable
                : false,
            tinNotAvlReason:
              checkValidationBasedOnDate(
                application?.createdAt || '',
                tin_declaration_validation_date
              ) && applicant?.tinNotAvailable === true
                ? applicant.tinNotAvlReason || ''
                : '',
            tinNotAvlReasonOthers:
              checkValidationBasedOnDate(
                application?.createdAt || '',
                tin_declaration_validation_date
              ) &&
              applicant?.tinNotAvailable === true &&
              OthersTINReason(applicant.tinNotAvlReason || '')
                ? applicant.tinNotAvlReasonOthers || ''
                : '',
          })),
          countryDropdown: nationalitiesMdmsMasters.countries.map((list) => list.name),
          allCountryDropdown: nationalitiesMdmsMasters.allCountries.map((list) => list.name),
        });
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, [application]);

  const handleSubmit = async (values: Values) => {
    try {
      const {
        applicants: existingApplicants = [],
        id,
        applicant1ReferenceId = '',
        currentStep,
        status,
        hasPOA,
        applicationNumber,
        createdAt,
      } = application || {};
      const { applicants, saveType } = values;
      applicants?.map((applicant, index) => {
        if (
          (applicant?.taxResidentOfAnyCountryOtherThanIndia || '')?.toString() === 'true' &&
          !applicant.tinNotAvailable &&
          checkValidationBasedOnDate(
            application?.createdAt || '',
            tin_declaration_validation_date
          ) &&
          (applicant?.isTinVerified ? applicant?.isTinVerified[0] : null) === null
        ) {
          throw `Tin Verification is mandatory for Applicant ${index + 1}`;
        }
      });
      const updatedPayload = existingApplicants.map((applicant, index: number) => {
        const {
          taxResidentOfAnyCountryOtherThanIndia = false,
          // dateOfBirth = '',
          dateOfIncorporation = '',
          ...rest
        } = applicants[index];
        return {
          ...applicant,
          taxResidentOfAnyCountryOtherThanIndia:
            taxResidentOfAnyCountryOtherThanIndia.toString() === 'false' ? false : true,
          // dateOfBirth: dateOfBirth ? dateOfBirth : null,
          dateOfIncorporation: dateOfIncorporation ? dateOfIncorporation : null,
          ...rest,
          placeOfBirth: removeSingleQuote(rest.placeOfBirth),
          taxCountryName:
            taxResidentOfAnyCountryOtherThanIndia.toString() === 'false'
              ? ''
              : removeSingleQuote(rest.taxCountryName),
          taxID: (
            checkValidationBasedOnDate(createdAt || '', tin_declaration_validation_date)
              ? taxResidentOfAnyCountryOtherThanIndia.toString() === 'false' || rest.tinNotAvailable
              : taxResidentOfAnyCountryOtherThanIndia.toString() === 'false'
          )
            ? ''
            : removeSingleQuote(rest.taxID),
          idType: (
            checkValidationBasedOnDate(createdAt || '', tin_declaration_validation_date)
              ? taxResidentOfAnyCountryOtherThanIndia.toString() === 'false' || rest.tinNotAvailable
              : taxResidentOfAnyCountryOtherThanIndia.toString() === 'false'
          )
            ? ''
            : removeSingleQuote(rest.idType),
          tinExists: !checkValidationBasedOnDate(createdAt || '', tin_declaration_validation_date)
            ? null
            : rest.tinExists,
          isTinVerified: [
            (
              checkValidationBasedOnDate(createdAt || '', tin_declaration_validation_date)
                ? taxResidentOfAnyCountryOtherThanIndia.toString() === 'false' || rest.tinExists
                : taxResidentOfAnyCountryOtherThanIndia.toString() === 'false'
            )
              ? null
              : rest.isTinVerified
              ? rest.isTinVerified[0]
              : null,
          ],
          tinNotAvailable:
            checkValidationBasedOnDate(
              application?.createdAt || '',
              tin_declaration_validation_date
            ) && isNriInvestorType(applicant.status || '')
              ? rest.tinNotAvailable
              : false,
          tinNotAvlReason:
            checkValidationBasedOnDate(
              application?.createdAt || '',
              tin_declaration_validation_date
            ) && rest?.tinNotAvailable === true
              ? rest.tinNotAvlReason || ''
              : '',
          tinNotAvlReasonOthers:
            checkValidationBasedOnDate(
              application?.createdAt || '',
              tin_declaration_validation_date
            ) &&
            rest?.tinNotAvailable === true &&
            OthersTINReason(rest.tinNotAvlReason || '')
              ? rest.tinNotAvlReasonOthers || ''
              : '',
        };
      });
      const isSaveLater = saveType !== 'save and proceed';
      const checkApplication = applicationComparison(application, {
        ...application,
        applicants: updatedPayload,
        currentStep:
          !!currentStep &&
          currentStep >
            getCurrentStep(
              application?.applicationType || '',
              path,
              false,
              isSaveLater,
              application?.createdAt,
              toggler
            ) -
              1
            ? currentStep
            : getCurrentStep(
                application?.applicationType || '',
                path,
                false,
                isSaveLater,
                application?.createdAt,
                toggler
              ),
      });

      if (id && !checkApplication) {
        setLoading(true);
        await dispatch(
          updateApplication({
            body: {
              ...application,
              applicants: updatedPayload,
              status:
                !hasPOA &&
                AMC_APPROVER_CHECK_FOR_INDIVIDUAL &&
                status !== 'draft' &&
                applyRoleBasedStatus(role)
                  ? 'sent_to_amc_approver'
                  : status,
              currentStep: getCurrentStep(
                application?.applicationType || '',
                path,
                false,
                isSaveLater,
                application?.createdAt,
                toggler
              ),
            },
            applicationId: id,
            ...(isSaveLater && { toastMessage: '' }),
          })
        );
        history.push(
          navigateToNextStep(
            path,
            role,
            id || '',
            isSaveLater,
            applicant1ReferenceId || '',
            application?.applicationType || '',
            false,
            application?.createdAt,
            toggler
          ),
          {
            id,
            applicant1ReferenceId,
          }
        );
      } else if (checkApplication) {
        if (isSaveLater) {
          enqueueSnackbar(`Application ${applicationNumber} - ` + ' Saved successfully', {
            variant: 'success',
            autoHideDuration: 3000,
          });
        }
        history.push(
          navigateToNextStep(
            path,
            role,
            id || '',
            isSaveLater,
            applicant1ReferenceId || '',
            application?.applicationType || '',
            false,
            application?.createdAt,
            toggler
          ),
          {
            id,
            applicant1ReferenceId,
          }
        );
      }
    } catch (e) {
      setLoading(false);
      typeof e === 'string' && dispatch(showError(e as string));
      console.error((e as Error).message);
    }
  };

  return (
    <Formik
      initialValues={fatcaDetails}
      onSubmit={handleSubmit}
      validate={(values: Values) => {
        try {
          validateYupSchema(
            values,
            FATCAValidationSchema(application?.createdAt || ''),
            true,
            values
          );
        } catch (e) {
          return yupToFormErrors(e);
        }
      }}
      enableReinitialize={true}>
      {({ handleSubmit, values, setValues }) => (
        <Grid
          container
          rowSpacing={1}
          // columnSpacing={5}
          sx={{
            width: '100%',
            ml: 0,
            '.MuiGrid-item': { px: { xs: 0, sm: '30px' } },
          }}
          component="form"
          noValidate
          onSubmit={handleSubmit}>
          <Notes
            displayContent={'FATCA Information is mandatory to disclose any Foreign Citizenship'}
          />
          {values.applicants.map((applicant, index) => (
            <FatcaDetails
              applicantName={getApplicantName(index + 1)}
              index={index}
              key={index}
              values={applicant}
              nationalitiesMdmsResponse={mdmsCountriesList}
              mdmsAllCountriesList={mdmsAllCountriesList}
              tinCountries={tinCountries}
              formvalues={values}
              setValues={setValues}
            />
          ))}
          <ProceedSaveLater
            saveLater={() => {
              setValues({
                ...values,
                saveType: 'save for later',
              });
            }}
            saveAndProceed={() => {
              setValues({
                ...values,
                saveType: 'save and proceed',
              });
            }}
            loader={loading}
            clickedButton={values.saveType}
          />
        </Grid>
      )}
    </Formik>
  );
}
